<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.user.new.title"> </sm-page-header>
  <!-- content -->
  <div class="content" *ngIf="!formDateLoading">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button [label]="'settings.user.new.add' | translate" (click)="addUser()" [disabled]="!isFormValid" />
      <p-button [label]="'settings.user.new.reset' | translate" severity="secondary" (click)="resetForm()" />
    </div>
  </div>
  <sm-spinner [loading]="formDateLoading"></sm-spinner>
</div>
